<script setup>
import { usePage } from "@inertiajs/vue3";
import Button from "primevue/button";

const props = defineProps({
    name: String,
    version: String,
    unrounded: Boolean,
    upgradeReasons: {
        type: Array,
        default: () => [],
    },
    inline: Boolean,
});

const features = usePage().props.user.features?.map((el) => el.feature_name);
const featureAvailable = features?.includes(props.name);

const changePlan = () => {
    window.location = '/subscribe-to-pro';
};
</script>

<template>
    <div class="relative h-full flex flex-col min-h-0">
        <div class="h-full flex flex-col min-h-0" :class="{ 'opacity-40 pointer-events-none': !featureAvailable }">
            <slot />
        </div>

        <div
            v-if="!featureAvailable && inline"
            class="mt-2 flex items-center gap-2 rounded border p-2 text-sm
                   border-neutral-200 dark:border-neutral-700
                   text-gray-700 dark:text-gray-400"
        >
            <i class="pi pi-crown text-yellow-500"></i>
            <span>
                {{ $t('common.feature_plan_available', { version }) }}
            </span>
        </div>

        <div
            v-if="!featureAvailable && !inline"
            class="absolute inset-0 z-40 flex items-center justify-center
                   bg-black/20 select-none"
            :class="{ 'rounded-xl': !unrounded }"
        >
            <div
                class="rounded-xl border flex flex-col gap-1 border-roori-blue/50
                       bg-roori-blue px-1.5 py-1
                        max-w-md"
            >
                <div class="flex items-center gap-4 pl-3 ">
                    <i class="pi pi-crown text-white text-2xl shrink-0"></i>

                    <p class="text-white text-sm flex-1">
                        {{ $t('common.feature_plan_available', { version }) }}
                    </p>

                    <Button
                        label="Upgrade"
                        icon="pi pi-arrow-up-right"
                        icon-pos="right"
                        size="small"
                        class="whitespace-nowrap
                           border-0
                           font-semibold
                           !bg-white !text-roori-blue
                           px-4 py-2
                           rounded-lg

                           text-xs
                           hover:shadow-lg
                           hover:scale-[1.02]
                           active:scale-[0.98]
                           transition-all duration-200"
                        @click="changePlan"
                    />
                </div>

                <slot name="button" />

            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
/* Jemná animace pro efekt */
.opacity-40 {
    transition: opacity 0.2s ease-in-out;
}
</style>
